import i18n from '@/i18n'
import store from '@/store'
import axios from 'axios'

const guard = async (to, from, next) => {
  const lang = to.params.lang || localStorage.getItem('lang') || to.meta.langDefault
  const changesLang = lang !== i18n.locale
  const doc = to.params.doc || to.meta.docDefault
  let version = to.params.version

  if (!version || process.env.VUE_APP_FORCE_LATEST_VERSION === 'yes') {
    version = store.state.global.latestVersion
  }

  // Set latest version
  if (!version) {
    version = await latestVersionFetch()
    return next(`${lang}/${doc}/${version}`)
  }

  // Set locale
  if (changesLang) {
    const locales = Object.keys(i18n.messages)
    const langDefault = localStorage.getItem('lang') || to.meta.langDefault

    if (!locales.includes(lang)) {
      return next(`${langDefault}/${doc}/${version}`)
    }

    i18n.locale = lang

    localStorage.setItem('lang', lang)
  }

  next()
}

const latestVersionFetch = () => {
  const api = process.env.VUE_APP_API
  const url = `${api}/latest.json`

  store.commit('global/SET_LOADING', true)

  return axios
    .get(url)
    .then(response => {
      const { version } = response.data

      store.commit('global/SET_LATEST_VERSION', version)
      store.commit('global/SET_LOADING', false)

      return version
    })
    .catch(error => {
      throw error
    })
}

export default guard
